//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('cargonizerPrinters', {
//        templateUrl: 'views/components/views/cargonizerPrinters/cargonizerPrinters.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['cargonizerPrintersService', function (cargonizerPrintersService) {
//			const vm = this;

//            vm.model = {
//                itemsListPrinters: []
//            };

//            async function loadCargonizerPrinters() {
//                vm.model.itemsListPrinters = await cargonizerPrintersService.listCargonizerPrinters();
//            }
            
//            vm.$onInit = async function () {
//                loadCargonizerPrinters();
//            }
//		}]
//	});
//})();
